export const SPANISH = 'spa';
export const ENGLISH = 'eng';
